/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */

import {ApiV0} from "../../api.v0";
import {
    ProductDetailMinRes,
    ProductDetailsRes,
    ProductReleaseReq,
    ProductUpdateCreateReq,
} from '../../../../contracts/v0/cp';
import {RestApiService} from '../../../rest-api.service';
import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

export const DEFAULT_PRODUCT_EXPAND_FIELDS: ExpandableProductDetails[] = ['Description.Translations', 'ShortDescription.Translations', 'Title.Translations', 'Text.Translations']
export declare type ExpandableProductDetails =
    'Description.Translations'
    | 'ShortDescription.Translations'
    | 'Title.Translations'
    | 'Text.Translations';

export class ApiV0Products {
    segment = '/product';

    constructor(v0: ApiV0, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }

    search(searchModel?: SearchModel): Observable<BaseCollectionModel<ProductDetailsRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<ProductDetailsRes>>(`${this.segment}/search`, BaseCollectionModel<ProductDetailsRes>, searchModel ? searchModel : new SearchModel({}));
    }
    minSearch(searchModel?:SearchModel): Observable<BaseCollectionModel<ProductDetailMinRes>> {
        return this.rest.post<SearchModel, BaseCollectionModel<ProductDetailMinRes>>(`${this.segment}/minsearch`, BaseCollectionModel<ProductDetailMinRes>, searchModel ? searchModel : new SearchModel({}));
    }

    details(id: string, expandFields: ExpandableProductDetails[] = DEFAULT_PRODUCT_EXPAND_FIELDS, excludeFields: string[] = []): Observable<ProductDetailsRes> {
        return this.rest.get<ProductDetailsRes>(
            `${this.segment}/${id}`,
            ProductDetailsRes,
            {
                params: {
                    "expandFields": expandFields.join(','),
                    "excludeFields": excludeFields.join(',')
                }
            }
        );
    }

    // @ts-ignore
    addProduct(product: ProductUpdateCreateReq): Observable<ProductDetailsRes> {
        return this.rest.post<ProductUpdateCreateReq, ProductDetailsRes>(
            `${this.segment}/`,
            ProductDetailsRes,
            product
        );
    }

    updateProduct(productId: string, product: ProductUpdateCreateReq): Observable<ProductDetailsRes> {
        return this.rest.patch<ProductUpdateCreateReq, ProductDetailsRes>(
            `${this.segment}/${productId}`,
            ProductDetailsRes,
            product
        );

    }

    release(productId: string, release: ProductReleaseReq): Observable<ProductDetailsRes> {
        release.productId = productId;
        return this.rest.post<ProductReleaseReq, ProductDetailsRes>(
            `${this.segment}/Release`,
            ProductDetailsRes,
            release
        );
    }
}
